<template>
  <div>
    STATUS DOCUMENT
    <hr>
    <b-form-group :class="{'error-input' : $v.data_status_document.title.$error}">
      <label> Status Document Title </label>
      <j-input
        v-model="$v.data_status_document.title.$model"
        :max-length="255"
        placeholder="Status Document Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeStatusDocument">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveStatusDocument">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_status_document: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_status_document: {
        title: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_channel']),

    generateDataStatusDocument() {
      const infoName = this.data_status_document.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_status_document.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataStatusDocumentUpdate() {
      const infoName = this.data_status_document.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_status_document.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_status_document.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveStatusDocument() {
      this.$v.data_status_document.$touch();
      if (!this.$v.data_status_document.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataStatusDocument;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataStatusDocumentUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeStatusDocument();
      }
    },

    closeStatusDocument() {
      this.$emit('close-field');
      this.data_status_document.title = null;
      setTimeout(() => {
        this.$v.data_status_document.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jStatusDocumentSetup.vue